/* global axios */
import ApiClient from '../ApiClient';

class OlxChannel extends ApiClient {
  constructor() {
    super('olx', { accountScoped: true });
  }

  generateAuthorization(payload) {
    return axios.post(`${this.url}/authorization`, payload);
  }
}

export default new OlxChannel();
